import styled from 'styled-components';

export const DiscountBannerWrapper = styled.div<{ margin?: string; isPlaced?: boolean }>`
  position: ${({ isPlaced }) => (isPlaced ? 'absolute' : 'relative')};
  top: ${({ theme, margin, isPlaced }) => (isPlaced ? margin || theme.spaces.space3 : 'initial')};
  right: ${({ theme, margin, isPlaced }) => (isPlaced ? margin || theme.spaces.space3 : 'initial')};
  padding: ${({ theme }) => theme.spaces.space2};
  border-radius: ${({ theme }) => theme.spaces.space1};
  background: ${({ theme }) => theme.semanticColors.redDark};
`;
